// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"308":"af8697c0","675":"c16eac2e","764":"90394e5b","935":"c64ccb43"}[chunkId] + ".css";
};